import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/1234567890" // Placeholder number
  target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white rounded-full shadow-lg hover:scale-110 transition-transform duration-300 group" aria-label="Chat on WhatsApp" data-id="element-162">
      <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-75 group-hover:opacity-100 transition-opacity duration-300" data-id="element-163" />
      <MessageCircle className="w-7 h-7 relative z-10" data-id="element-164" />
    </a>;
}